export default __webpack_public_path__ + "static/media/lesson_feature001.ea6d0c80.png";